import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';
import logo from '../../../public/DevontisLogo.svg';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: 'Company',
      links: [
        { label: 'About Us', path: '/about' },
        { label: 'Services', path: '/services' },
        { label: 'Process', path: '/process' },
        { label: 'Industries', path: '/industries' },
      ],
    },
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://linkedin.com' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com' },
    { name: 'GitHub', icon: 'Github', url: 'https://github.com' },
    { name: 'Facebook', icon: 'Facebook', url: 'https://facebook.com' },
  ];

  return (
    <footer className="bg-white border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          <div className="lg:col-span-2">
            <Link to="/homepage" className="flex items-center space-x-3 mb-4">
             <img src={logo} alt="Devontis Logo" className="w-30 h-10" />
            </Link>
            <p className="text-muted-foreground text-sm font-body mb-4 max-w-md">
              Transforming SaaS visions into reality through expert development partnership. 
              We combine technical excellence with strategic thinking to deliver exceptional results.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-md bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-200"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          {footerSections?.map((section) => (
            <div key={section?.title}>
              <h3 className="text-sm font-semibold font-headline text-foreground mb-4">
                {section?.title}
              </h3>
              <ul className="space-y-3">
                {section?.links?.map((link) => (
                  <li key={link?.label}>
                    <Link
                      to={link?.path}
                      className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-200"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm font-body text-muted-foreground">
              © {currentYear} Devontis Technologies Private Limited. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/contact"
                className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center space-x-2"
              >
                <Icon name="Mail" size={16} />
                <span>Contact Us</span>
              </Link>
              <a
                href="tel:+91 9811143590"
                className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center space-x-2"
              >
                <Icon name="Phone" size={16} />
                <span>+91 9811143590</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;